export const ru = {
  common: {
    back: 'Назад',
    logout: 'Выйти',
    themeDark: 'Тёмная тема',
    themeLight: 'Светлая тема',
    save: 'Сохранить',
    cancel: 'Отмена',
    create: 'Создать',
    close: 'Закрыть',
    copy: 'Скопировать',
    copied: 'Ссылка скопирована',
    search: 'Поиск',
    loading: 'Загрузка…',
    retry: 'Повторить',
    language: 'English',
    optional: 'необязательно',
  },
  nav: {
    packages: 'Абонементы',
    today: 'Сегодня',
    schedule: 'Расписание',
    people: 'Люди',
    courses: 'Курсы',
    invites: 'Приглашения',
    settings: 'Настройки',
    label: 'Разделы',
  },
  subscription: {
    days_one: '{{count}} день',
    days_few: '{{count}} дня',
    days_many: '{{count}} дней',
    days_other: '{{count}} дня',
    trialEnds:
      'Пробный период заканчивается {{date}} — осталось {{days}}. Чтобы продолжить без перерыва, напишите нам: <mail>{{email}}</mail>.',
    ends: 'Подписка заканчивается {{date}} — осталось {{days}}. Продлите её, чтобы кабинет работал без перерыва: <mail>{{email}}</mail>.',
    grace:
      'Подписка закончилась {{date}}. Через {{days}} кабинет перейдёт в режим «только чтение». Продлить: <mail>{{email}}</mail>.',
    expiredAdmin:
      'Режим «только чтение»: подписка закончилась {{date}}. Расписание и данные видны, но изменения недоступны. Чтобы продлить, напишите на <mail>{{email}}</mail>.',
    expired: 'Кабинет школы временно в режиме «только чтение»: расписание видно, изменения недоступны.',
    impersonated: 'Поддержка Aurea: вы вошли как владелец школы — {{name}}. Сессия закроется через час.',
  },
  roles: { admin: 'Администратор', teacher: 'Учитель', student: 'Ученик' },
  errors: {
    UNAUTHENTICATED: 'Нужно войти заново',
    INVALID_CREDENTIALS: 'Неверный e-mail или пароль',
    FORBIDDEN: 'Недостаточно прав',
    NOT_FOUND: 'Не найдено',
    VALIDATION_FAILED: 'Проверьте поля формы',
    CONFLICT: 'Такая запись уже есть',
    PLAN_LIMIT_REACHED:
      'Достигнут лимит тарифа: {{used}} из {{limit}}. Чтобы добавить больше, свяжитесь с Aurea.',
    SCHEDULE_CONFLICT: 'У преподавателя в это время другое занятие',
    SUBSCRIPTION_EXPIRED: 'Подписка школы закончилась, изменения недоступны',
    SCHOOL_UNAVAILABLE: 'Доступ к школе приостановлен',
    INVITE_INVALID: 'Ссылка устарела, отозвана или уже использована',
    RATE_LIMITED: 'Слишком много попыток, подождите минуту',
    CSRF: 'Обновите страницу и попробуйте ещё раз',
    INTERNAL: 'Что-то пошло не так. Попробуйте ещё раз',
  },
  login: {
    title: 'Вход',
    email: 'E-mail',
    password: 'Пароль',
    remember: 'Запомнить меня на 30 дней',
    submit: 'Войти',
    forgot: 'Забыли пароль?',
  },
  forgot: {
    title: 'Сброс пароля',
    lead: 'Укажите e-mail, с которым входите. Пришлём ссылку для нового пароля.',
    sent: 'Если такой e-mail есть в школе, мы отправили на него ссылку. Она действует 1 час.',
    submit: 'Прислать ссылку',
    back: 'Вернуться ко входу',
  },
  setup: {
    title: 'Придумайте пароль',
    hello: '{{name}}, это ваш кабинет. Осталось задать пароль для входа ({{email}}).',
    password: 'Новый пароль',
    hint: 'Не короче 10 символов',
    submit: 'Сохранить и войти',
  },
  join: {
    title: 'Регистрация',
    invited: 'Вас пригласили в школу «{{school}}»',
    course: 'Курс: {{course}}',
    group: 'группа «{{group}}»',
    firstName: 'Имя',
    lastName: 'Фамилия',
    email: 'E-mail',
    phone: 'Телефон',
    password: 'Пароль',
    consent: 'Я соглашаюсь на обработку персональных данных школой «{{school}}»',
    submit: 'Зарегистрироваться',
    emailTaken: 'Этот e-mail уже зарегистрирован. Войдите в кабинет.',
    toLogin: 'У меня уже есть аккаунт',
  },
  today: {
    title: 'Сегодня',
    now: 'сейчас {{time}}',
    summary: '{{lessons}} сегодня · {{done}} проведено · {{teachers}}',
    inMinutes: 'через {{count}} мин',
    inHours: 'через {{count}} ч',
    soon: 'скоро',
    mark: 'Отметить',
    unmarked: 'не отмечено',
    donePile: 'Проведено: {{lessons}}',
    morePile: 'Ещё {{lessons}}',
    openDay: 'открыть день по учителям',
    empty: 'Сегодня занятий нет',
    emptyHint: 'Занятия на неделю видны в расписании.',
    newLesson: 'Новое занятие',
  },
  attention: {
    unmarked: 'Нужно отметить',
    allMarked: 'Всё отмечено',
    allMarkedHint: 'Прошедшие занятия без отметки появятся здесь.',
    subscription: 'Подписка Aurea',
    plan: 'Тариф «{{plan}}», оплачено до {{date}}',
    expired: 'Подписка закончилась {{date}}. Изменения недоступны, свяжитесь с Aurea.',
    teachers: 'Учителя',
    students: 'Ученики',
    of: '{{used}} из {{max}}',
    unlimited: '{{used}}, без ограничения',
  },
  schedule: {
    title: 'Расписание',
    day: 'День по учителям',
    week: 'Неделя',
    month: 'Месяц',
    more_one: 'ещё {{count}}',
    more_few: 'ещё {{count}}',
    more_many: 'ещё {{count}}',
    more_other: 'ещё {{count}}',
    allTeachers: 'Все учителя',
    teacher: 'Учитель',
    prev: 'Назад',
    next: 'Вперёд',
    today: 'Сегодня',
    scrollHint: '{{teachers}} · листайте вбок, чтобы увидеть всех',
    free: 'свободен',
    pileLabel: '{{lessons}} с {{from}} до {{to}}: показать день по учителям',
    moved: '«{{title}}» перенесено на {{when}}',
    teacherChanged: '«{{title}}» в {{time}} теперь ведёт {{teacher}}',
    keyboardHint: 'Стрелки переносят занятие',
    cancelled: 'отменено',
  },
  feed: {
    button: 'В свой календарь',
    title: 'Расписание в вашем календаре',
    lead: 'Подпишитесь на личную ссылку — занятия появятся в Google Календаре, Apple Календаре или Outlook и будут обновляться сами.',
    get: 'Получить ссылку',
    google: 'Google Календарь: «Другие календари» → «+» → «Добавить по URL».',
    apple: 'iPhone и Mac: «Календарь» → «Добавить подписку» и вставьте ссылку.',
    outlook: 'Outlook: «Добавить календарь» → «Подписаться из интернета».',
    secret: 'Ссылка личная, никому её не пересылайте. Новая ссылка отменяет прежнюю.',
  },
  lesson: {
    cancel: 'Отменить занятие',
    cancelConfirm: 'Отменить',
    cancelReason: 'Причина',
    scopeThis: 'Только это',
    scopeFollowing: 'Это и все следующие',
    scopeAll: 'Все будущие',
    edit: 'Изменить занятие',
    seriesHint:
      'Даты серии остаются прежними. Занятия, перенесённые вручную, сохранят своё время, но получат нового учителя и длительность.',
    changed_one: 'Изменено {{count}} занятие',
    changed_few: 'Изменено {{count}} занятия',
    changed_many: 'Изменено {{count}} занятий',
    changed_other: 'Изменено {{count}} занятия',
    cancelled_one: 'Отменено {{count}} занятие',
    cancelled_few: 'Отменено {{count}} занятия',
    cancelled_many: 'Отменено {{count}} занятий',
    cancelled_other: 'Отменено {{count}} занятия',
    isCancelled: 'Занятие отменено',
    notStarted: 'Посещаемость можно отметить, когда занятие начнётся.',
    saveMarks: 'Сохранить отметки',
    group: 'группа «{{name}}»',
    online: 'Онлайн',
    attendance: 'Отметить посещаемость',
    present: 'Был',
    absent: 'Не был',
    excused: 'Уваж.',
    complete: 'Завершить занятие',
    note: 'Присутствие спишет занятие из абонемента.',
    completed: 'Занятие завершено. Списано из абонементов: {{charged}}.',
    uncharged: 'Без абонемента: {{count}} — они появятся в долгах.',
    noStudents: 'В занятии нет учеников.',
  },
  lessonForm: {
    title: 'Новое занятие',
    course: 'Курс',
    pickCourse: 'Выберите курс',
    group: 'Группа',
    pickGroup: 'Выберите группу',
    noGroups: 'У курса пока нет групп',
    student: 'Ученик',
    pickStudent: 'Выберите ученика',
    pickTeacher: 'Выберите учителя',
    courseTeacher: 'ведёт курс',
    date: 'Дата',
    time: 'Начало',
    duration: 'Минут',
    location: 'Место',
    locationHint: 'каб. 2',
    onlineUrl: 'Ссылка на встречу',
    urlHint: 'Нужна ссылка, начинающаяся с https://',
    repeat: 'Повторять',
    weekdays: 'По дням',
    every: 'Как часто',
    everyWeek: 'Каждую неделю',
    everyTwoWeeks: 'Раз в две недели',
    end: 'До',
    endOpen: 'Без даты окончания',
    endUntil: 'До даты',
    endCount: 'Число занятий',
    untilDate: 'Последний день',
    countLabel: 'Сколько занятий',
    openHint: 'Занятия создаются на 12 недель вперёд и продлеваются автоматически.',
    conflicts: 'У учителя уже есть занятия в это время:',
    created: 'Создано: {{lessons}}',
  },
  billing: {
    days: '{{count}} дн.',
    ofTotal: 'из {{total}}',
    title: 'Абонементы',
    templates: 'Виды абонементов',
    newTemplate: 'Вид абонемента',
    templateName: 'Название',
    templateNameHint: 'Например «Английский, 8 занятий»',
    appliesTo: 'На что действует',
    anyLesson: 'На любые занятия',
    lessonsCount: 'Занятий',
    price: 'Цена, ₽',
    validity: 'Срок, дней',
    validityHint: 'Пусто — бессрочно',
    sold: 'Продано: {{count}}',
    noTemplates: 'Видов абонементов пока нет. Создайте первый, например «8 занятий за месяц».',
    expiring: 'Заканчиваются',
    expiringEmpty: 'Ни у кого абонемент не заканчивается.',
    debtors: 'Должники',
    debtorsEmpty: 'Должников нет.',
    left: '{{left}} из {{total}}',
    until: 'до {{date}}',
    forever: 'бессрочный',
    debtLessons: 'без абонемента: {{lessons}}',
    owes: 'долг {{amount}}',
    archive: 'Убрать',
    sell: 'Продать абонемент',
    sellTitle: 'Новый абонемент для {{name}}',
    template: 'Вид абонемента',
    custom: 'Свой вариант',
    startsOn: 'Начало',
    paidNow: 'Оплачено сейчас, ₽',
    method: 'Способ оплаты',
    methods: { cash: 'Наличные', card: 'Карта', transfer: 'Перевод', other: 'Другое' },
    soldToast: 'Абонемент добавлен',
    coveredToast: 'Абонемент добавлен. Списано долговых занятий: {{count}}',
    payment: 'Принять оплату',
    amount: 'Сумма, ₽',
    forPackage: 'За абонемент',
    noPackage: 'Без привязки',
    comment: 'Комментарий',
    paidToast: 'Оплата {{amount}} записана',
    adjust: 'Корректировка',
    adjustTitle: 'Изменить число занятий',
    delta: 'Сколько добавить (или убрать, с минусом)',
    reason: 'Причина',
    reasonHint: 'Попадёт в журнал',
    adjustedToast: 'Абонемент изменён',
    balance: 'Баланс',
    balanceOk: 'Долгов нет',
    payments: 'Оплаты',
    noPayments: 'Оплат пока нет',
    history: 'Занятия',
    noHistory: 'Проведённых занятий пока нет',
    charged: 'списано: {{name}}',
    notCharged: 'не списано',
    noPackages: 'Абонементов пока нет',
    paidOf: 'оплачено {{paid}} из {{price}}',
    status: { active: 'действует', exhausted: 'закончился', expired: 'истёк', cancelled: 'отменён' },
    attendance: { present: 'был', absent: 'не был', excused: 'уваж.', unmarked: 'не отмечен' },
    card: 'Карточка ученика',
    back: 'Все ученики',
    my: 'Мои абонементы',
  },
  people: {
    title: 'Люди',
    all: 'Все',
    add: 'Добавить',
    search: 'Имя, e-mail или телефон',
    name: 'Имя',
    email: 'E-mail',
    roles: 'Роли',
    courses: 'Курсы',
    lastLogin: 'Последний вход',
    never: 'не входил',
    owner: 'владелец',
    empty: 'Никого не нашли',
    formTitle: 'Новый пользователь',
    firstName: 'Имя',
    lastName: 'Фамилия',
    phone: 'Телефон',
    role: 'Роль',
    created: 'Пользователь создан. Отправьте ему ссылку для входа:',
  },
  users: {
    edit: 'Изменить',
    editName: 'Изменить: {{name}}',
    show: 'Показывать',
    status: { active: 'Активные', blocked: 'Заблокированные', archived: 'В архиве' },
    saved: 'Сохранено',
    sendLink: 'Отправить ссылку для входа',
    linkSent: 'Письмо отправлено. Старые ссылки больше не работают. Ссылку можно передать и самому:',
    block: 'Заблокировать',
    blockHint: 'Не сможет войти. Курсы и занятия остаются — для временной паузы.',
    archive: 'В архив',
    archiveHint: 'Человек ушёл: отчисляем с курсов и убираем из будущих занятий. История остаётся.',
    restore: 'Вернуть',
    restored: 'Доступ возвращён',
    blocked: 'Заблокирован, сессии закрыты',
    archived: 'Перенесён в архив',
    teacherLessons_one: 'Готово. У учителя осталось {{count}} будущее занятие — назначьте замену',
    teacherLessons_few: 'Готово. У учителя осталось {{count}} будущих занятия — назначьте замену',
    teacherLessons_many: 'Готово. У учителя осталось {{count}} будущих занятий — назначьте замену',
    teacherLessons_other: 'Готово. У учителя осталось {{count}} будущих занятий — назначьте замену',
    emailTaken: 'Такой e-mail уже есть в школе',
    reasons: {
      KEEP_ADMIN: 'Владелец школы и вы сами не можете лишиться прав администратора',
      SELF_OR_OWNER: 'Нельзя заблокировать себя или владельца школы',
      NOT_ACTIVE: 'Сначала верните пользователю доступ',
    },
  },
  import: {
    button: 'Импорт',
    title: 'Импорт учеников из CSV',
    lead: 'Сохраните таблицу из Excel или Google Таблиц как CSV. Колонки: Фамилия, Имя, E-mail и, по желанию, Телефон — или одна колонка «ФИО». Заголовки можно не добавлять.',
    pick: 'Выбрать файл',
    found_one: 'Готово к импорту: {{count}} ученик',
    found_few: 'Готово к импорту: {{count}} ученика',
    found_many: 'Готово к импорту: {{count}} учеников',
    found_other: 'Готово к импорту: {{count}} ученика',
    bad_one: '{{count}} строка с ошибкой будет пропущена',
    bad_few: '{{count}} строки с ошибками будут пропущены',
    bad_many: '{{count}} строк с ошибками будут пропущены',
    bad_other: '{{count}} строки с ошибками будут пропущены',
    more: 'и ещё {{count}}',
    errors: { NAME: 'нет имени или фамилии', EMAIL: 'неверный e-mail' },
    target: 'Записать на курс',
    noTarget: 'Не записывать',
    sendInvites: 'Отправить ученикам письма со ссылкой для входа',
    run_one: 'Импортировать {{count}} ученика',
    run_few: 'Импортировать {{count}} ученика',
    run_many: 'Импортировать {{count}} учеников',
    run_other: 'Импортировать {{count}} ученика',
    done_one: 'Добавлен {{count}} ученик',
    done_few: 'Добавлено {{count}} ученика',
    done_many: 'Добавлено {{count}} учеников',
    done_other: 'Добавлено {{count}} ученика',
    invitesSent: 'Письма со ссылкой для входа отправлены.',
    skipped: {
      EXISTS: 'Строка {{row}}: {{email}} уже есть в школе — пропущена',
      DUPLICATE: 'Строка {{row}}: {{email}} повторяется в файле — пропущена',
    },
  },
  courses: {
    title: 'Курсы',
    disciplines: 'Дисциплины',
    addDiscipline: 'Дисциплина',
    addCourse: 'Курс',
    disciplineName: 'Название дисциплины',
    color: 'Цвет бумаги',
    courseName: 'Название курса',
    discipline: 'Дисциплина',
    format: 'Формат',
    individual: 'Индивидуальный',
    group: 'Групповой',
    mixed: 'Смешанный',
    duration: 'Длительность занятия, мин',
    teachers: 'Учителя',
    groupsCount: 'Групп: {{count}}',
    minutes: '{{count}} мин',
    empty: 'Курсов пока нет. Начните с дисциплины, например «Английский язык».',
  },
  groups: {
    new: 'Группа',
    edit: 'Изменить группу',
    name: 'Название группы',
    teacher: 'Учитель',
    noTeacher: 'Не назначен',
    capacity: 'Мест',
    capacityHint: 'Пусто — без ограничения',
    seats: 'Учеников / мест',
    seatsOf: 'Учеников: {{count}} из {{capacity}}',
    empty: 'В группе пока никого. Добавьте учеников ниже или пришлите им ссылку-приглашение в эту группу.',
    add: 'Добавить ученика',
    addButton: 'Добавить',
    pickStudent: 'Выберите ученика',
    full: 'Мест нет',
    move: 'Перевести…',
    moveTo: 'Перевести: {{name}}',
    solo: 'Индивидуально',
    remove: 'Убрать из группы и курса: {{name}}',
    removeFromCourse: 'Отчислить с курса «{{name}}»',
    removeHint: 'Отчислить с курса. Прошедшие занятия и списания останутся в истории.',
    archive: 'В архив',
    archiveHint: 'Сначала переведите учеников в другую группу',
    courses: 'Курсы',
    course: 'Курс',
    group: 'Группа',
    enroll: 'Записать на курс',
    enrollButton: 'Записать',
    allCourses: 'Ученик уже записан на все курсы школы.',
    noCourses: 'Пока ни на один курс не записан.',
    reasons: {
      GROUP_FULL: 'В группе нет свободных мест ({{capacity}})',
      ALREADY_ENROLLED: 'Ученик уже записан на этот курс',
      GROUP_NOT_EMPTY: 'В группе ещё есть ученики',
      CAPACITY_BELOW_MEMBERS: 'В группе уже {{members}} учеников — мест не может быть меньше',
    },
  },
  invites: {
    title: 'Приглашения',
    create: 'Новая ссылка',
    label: 'Подпись',
    labelHint: 'Например «Набор в B1, сентябрь»',
    role: 'Кого приглашаем',
    group: 'Сразу записать в группу',
    noGroup: 'Без группы',
    expires: 'Действует, дней',
    maxUses: 'Сколько раз можно использовать',
    used: 'Использована: {{used}}',
    usedOf: 'Использована: {{used}} из {{max}}',
    until: 'до {{date}}',
    revoke: 'Отозвать',
    revoked: 'отозвана',
    empty: 'Ссылок пока нет. Создайте ссылку и отправьте её ученикам или повесьте QR-код в школе.',
    created: 'Ссылка создана и скопирована. Её видно только сейчас:',
  },
  settings: {
    title: 'Настройки школы',
    look: 'Как выглядит школа',
    name: 'Название',
    color: 'Цвет школы',
    logo: 'Логотип',
    logoUpload: 'Загрузить логотип',
    logoReplace: 'Заменить',
    logoRemove: 'Убрать',
    logoHint: 'PNG, JPEG или WebP. Квадратный выглядит лучше всего.',
    timeAndLanguage: 'Время и язык',
    timezone: 'Часовой пояс',
    locale: 'Язык по умолчанию',
    localeHint: 'Каждый может переключить язык для себя.',
    workdayStart: 'Рабочий день с',
    workdayEnd: 'до',
    workdayHint: 'Столько часов календарь показывает всегда.',
    workdayOrder: 'Конец дня должен быть позже начала',
    rules: 'Правила',
    rule: {
      chargeAbsent: 'Списывать занятие за пропуск',
      teacherCanReschedule: 'Учителя сами переносят свои занятия',
      showGroupMembers: 'Ученики видят состав группы',
      notifyLessonChanges: 'Письма о переносе и отмене занятий',
    },
    ruleHint: {
      chargeAbsent: 'Если ученик отмечен «Не был», занятие всё равно списывается из абонемента.',
      teacherCanReschedule: 'Без этого переносит только администратор.',
      showGroupMembers: 'Имена одногруппников видны в карточке занятия.',
      notifyLessonChanges: 'Ученики и учитель получают письмо, когда занятие перенесли или отменили.',
    },
    save: 'Сохранить',
    saved: 'Настройки сохранены',
  },
  colors: {
    lemon: 'Лимон',
    apricot: 'Абрикос',
    pink: 'Розовый',
    lilac: 'Сирень',
    sky: 'Небо',
    mint: 'Мята',
    sage: 'Шалфей',
    sand: 'Песок',
  },
  plural: {
    lessons_one: '{{count}} занятие',
    lessons_few: '{{count}} занятия',
    lessons_many: '{{count}} занятий',
    lessons_other: '{{count}} занятия',
    teachers_one: '{{count}} учитель',
    teachers_few: '{{count}} учителя',
    teachers_many: '{{count}} учителей',
    teachers_other: '{{count}} учителя',
    students_one: '{{count}} ученик',
    students_few: '{{count}} ученика',
    students_many: '{{count}} учеников',
    students_other: '{{count}} ученика',
  },
};

export type Messages = typeof ru;
